export interface IWarehouse {
  idWarehouse: string;
  idBranch: string;
  name: string;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export class Warehouse {
  idWarehouse: string;
  idBranch: string;
  name: string;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IWarehouse) {
    this.idWarehouse = data.idWarehouse;
    this.idBranch = data.idBranch;
    this.name = data.name;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
